import fetcher from './fetcher';

export function getTripActivityLog({ tripId }) {
  return fetcher({
    url: `/api/v3/admin/activity_logs/trip/${tripId}`,
    method: 'GET'
  });
}
